<template>
	<div class="center_cart_container">

		<div class="list_title">
			<div class="title">购物车</div>
			<div class="tag">&nbsp;</div>
		</div>


		<!-- 购物车产品清单 -->
		<div class="list" v-if="productData && productData.list && productData.list.length>0">
			<div class="item" v-for="(item, index) in productData.list" :key="index">
				<img class="cover" v-if="item.teacher_list && item.teacher_list.length>0"
					:src="item.teacher_list[0].img_url" />
				<div class="mes">
					<div class="title">{{item.title}}</div>
					<div class="info">
						<div class="price">¥{{item.price}}</div>
						<div class="delbox" @click="cartDelClick(item)">
							<i class="el-icon-delete del_icon"></i>
							<span class="del_text" style="">移除</span>
						</div>
					</div>
				</div>
			</div>

			<div class="toatl_panel">
				<div class="toatl_texts">
					共计支付<span class="total_val_span">¥ {{total}}</span>
				</div>
				<div class="total_btns">
					<div class="btn continue" @click="toList()">继续选择</div>
					<div class="btn confirm" @click="productConfirm">立即提交</div>
				</div>
			</div>
		</div>
		
		
		<div class="empty_box" v-if="productData.list && productData.list.length==0">
			<img class="empty_icon" src="../../assets/images/empty.png" />
			<div class="empty_texts" @click="toList()">
				<span class="empty_text">您的购物车是空的</span>
				<span class="empty_link">去看看有哪些课程</span>
			</div>
		</div>





	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";

	export default {
		data() {
			return {
				productData: {
					total: 0,
					count: 0,
					list: null,
				},
				total: '0.00',
			}
		},
		created() {
			document.title = "机工教师特训营";
			this.getProductData();
		},
		methods: {
			toList() {
				this.GoToChangeTab(4);
			},
			cartDelClick(item) {
				var that = this;
				var url = apiUrl.tt_course_cart_del;
				var parm = {
					cart_id: item.cart_id
				};
				this.Ajax(url, parm, function(data) {
					
					if (that.productData.list) {
						that.productData.list.forEach((tem, dex) => {
							if (tem.cart_id == item.cart_id) {
								that.productData.list.splice(dex, 1);
							}
						});
						var total = 0.00;
						that.productData.list.forEach((tem, dex) => {
							total += parseFloat(item.price);
						});
						that.total = total.toFixed(2);
						
						that.$emit('updateCartProductCount', data.cart_product_count);
						var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
						if (userInfo) {
							userInfo.cart_product_count = data.cart_product_count;
							localStorage.setItem("userLogInInfo", JSON.stringify(userInfo));
						}	
					}

				});
			},
			getProductData() {
				var that = this;
				var url = apiUrl.tt_course_cart_list_get;
				this.Ajax(url, {
					page_index: 1,
					page_size: 200
				},  (data, code, msg) => {
					if (code == 0 && data) {
						that.productData = data;
						if (that.productData.list) {
							var total = 0.00;
							that.productData.list.forEach((item, index) => {
								total += parseFloat(item.price);
							});
							that.total = total.toFixed(2);
						}
					}else if(code == 40004){
						that.productData.list = [];
					}
				});
			},
			//提交确认
			productConfirm() {
				var that = this;
				var url = apiUrl.tt_course_cart_confirm;
				this.Ajax(url, {}, (data) => {
					if (data) {
						that.$emit('updateCartProductCount', 0);
						var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
						if (userInfo) {
							userInfo.cart_product_count = 0;
							localStorage.setItem("userLogInInfo", JSON.stringify(userInfo));
						}
						
						this.$emit('selectedClick', 5);
					}
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
	.center_cart_container {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #fff;

		.empty_box {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		
			.empty_icon {
				width: 220px;
				height: auto;
			}
		
			.empty_texts {
				display: flex;
				flex-direction: column;
				color: #C0C4CC;
				line-height: 1;
				cursor: pointer;
		
				.empty_text {
					font-size: 15px;
					margin-bottom: 10px;
					text-align: center;
				}
		
				.empty_link {
					font-size: 17px;
					border-bottom: 1px solid #C0C4CC;
					padding-bottom: 2px;
					text-align: center;
				}
			}
		}

		.list_title {
			display: flex;
			align-items: flex-end;

			.title {
				font-size: 17px;
				margin-right: 15px;
			}

			.tag {
				font-size: 12px;
				color: #FBA559;
				margin-bottom: 3px;
			}
		}

		.list {
			width: 100%;
			display: flex;
			flex-direction: column;
			box-sizing: border-box;
			margin-top: 20px;

			.toatl_panel {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				padding: 15px 0;
				box-sizing: border-box;

				.toatl_texts {
					margin-bottom: 20px;
					font-size: 14px;


					.total_val_span {
						margin-left: 10px;
						color: #C93A2E;
						font-size: 18px;
					}

				}

				.total_btns {
					display: flex;
					justify-content: flex-end;
					font-size: 14px;

					.btn {
						display: flex;
						width: 120px;
						height: 40px;
						justify-content: center;
						align-items: center;
						box-sizing: border-box;
						border-radius: 4px;
						cursor: pointer;
						
						&.continue{
							background-color: #fff;
							border: 1px solid #C93A2E;
							color: #C93A2E;
						}
						
						&.confirm{
							background-color: #C93A2E; 
							color: #fff; 
						}
					}
					
					.btn+.btn{
						margin-left: 20px;
					}
				}
			}

			.item {
				width: 100%;
				display: flex;
				padding: 15px 0;
				box-sizing: border-box;
				border-bottom: 1px solid #eeeeee;

				&.noborder {
					border: 0;
				}

				.cover {
					width: 121px;
					height: 160px;
					box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);
					-o-object-fit: cover;
					object-fit: cover;
					position: relative;
					border-radius: 5px;
				}

				.mes {
					flex: 1;
					margin-left: 20px;
					display: flex;
					flex-direction: column;
					position: relative;

					.title {
						color: #333333;
						font-size: 16px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
					}

					.info {
						width: 100%;
						position: absolute;
						right: 0;
						bottom: 0;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.price {
							font-size: 16px;
							color: #C93A2E;
						}

						.delbox {
							display: flex;
							align-items: flex-start;
							cursor: pointer;

							.del_icon {
								font-size: 18px;
								color: #aaa;
							}

							.del_text {
								margin-left: 8px;
								font-size: 14px;
								color: #aaa;
							}
						}
					}
				}
			}
		}
	}
</style>